import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ControleAcessosSigService } from '../services/login/controle-acesse-sig.service';
import { LoginCommonService } from '../services/common/login-common.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CommonService } from '../services/common/common.service';
import { ValidatorService } from '../services/validators/errors-validators.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AppComponent } from '../app.component';
import { MatDialog } from '@angular/material/dialog';
import { showError } from 'src/utils/showErrorMessage';

@Component({
  selector: 'spe-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss'],
  standalone: false
})
export class AuthComponent implements OnInit {
  private subscriptions: Subscription[] = [];
  public mainFormGroup = new FormGroup({
    id: new FormControl('', [Validators.required]),
    token: new FormControl('', [Validators.required])
  });
  validatorErrors = this.validatorService.validatorErrors;
  private authKey?: string;
  private idCliente?: string;

  constructor(
    readonly validatorService: ValidatorService,
    readonly commonService: CommonService,
    private routerService: Router,
    public readonly loginCommonService: LoginCommonService,
    private controleAcessosSigService: ControleAcessosSigService,
    private activatedRoute: ActivatedRoute,
    private appComponent: AppComponent,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.appComponent.hideHeader = true;
    const queryParamsSubscription = this.activatedRoute.queryParams.subscribe((params) => {
      this.authKey = params.authKey;
      this.idCliente = params.ID_CLIENTE;

      if (this.authKey != undefined) {
        this.mainFormGroup.patchValue({
          id: this.idCliente,
          token: this.authKey
        });
        this.login();
      } else {
        this.routerService.navigate(['login/auth']);
      }
    });
    this.subscriptions.push(queryParamsSubscription);
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  public loginButton() {
    this.mainFormGroup.markAllAsTouched();
    if (this.mainFormGroup.valid) {
      this.login();
    }
  }

  private login() {
    const subscription = this.controleAcessosSigService
      .logar(this.mainFormGroup.value.id!, this.mainFormGroup.value.token!)
      .subscribe({
        next: (data) => {
          if (data.usuario.idParceria == 2) {
            localStorage.setItem('BRAND-THEME', 'cef');
          } else {
            localStorage.setItem('BRAND-THEME', 'undefined');
          }
          localStorage.setItem('SIG', data.usuario.loginSIG);
          this.loginCommonService.setUserData(data.usuario, true, true);
          this.routerService.navigate(['home']).then(() => {
            window.location.reload();
          });
        },
        error: (error) => {
          this.routerService.navigate(['login/auth']);
          setTimeout(() => {
            showError(this.dialog, error?.error?.erros[0]?.mensagem ?? error?.error?.mensagem);
          }, 100);
        }
      });
    this.subscriptions.push(subscription);
  }
}
